module.exports = __webpack_public_path__ + "static/media/video1.8d9cad69.mp4";